import api from "api";
import { sessionRequestConfig } from "helpers/session";

// Os logins recebem o refresh token no cookie: vão com o header e com credenciais.
const login = {
    signIn: (payload) => {
        return api(false, true).post('/users/login', payload, sessionRequestConfig());
    },
    
    forgotPassword: (paylaod) => {
        return api(false, true).post(`/users/forgotten-password`, paylaod);
    },

    verifyCode: (paylaod) => {
        return api(false, true).post(`/users/verified-code`, paylaod);
    },

    resendConfirmCode: (paylaod) => {
        return api(false, true).post(`/users/resend-confirm-code`, paylaod);
    },

    changePassword: (paylaod) => {
        return api(false, true).post('/users/change-password', paylaod);
    },

    withGoogle: (payload) => {
        return api(false, true).post('/users/google/login', payload, sessionRequestConfig());
    },

    withApple: (payload) => {
        return api(false, true).post('/users/apple/login', payload, sessionRequestConfig());
    },

    appleNonce: () => {
        return api(false, true).get('/users/apple/nonce');
    },

    confirmEmail: (email, code) => {
        return api(false, true).get(`/users/confirm/${email}/${code}`);
    }
};
 
export default login;